export function PageWelcome({ title, subtitle, actions }) {
  return (
    <div className="page-welcome">
      <div>
        <h2 className="page-welcome-title" data-tour="page-title">
          {title}
        </h2>
        {subtitle ? <p className="page-welcome-sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="page-welcome-actions">{actions}</div> : null}
    </div>
  );
}
